import React from 'react';
import { Button } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { MTable } from '../../../../../Components';
import { OnboardingDraftText, useOnboardingDraft } from './OnboardingDraft';
import { useStyles } from './Onboarding.styles';

export const OnboardingCompanyUnits = () => {
  const { draft, update } = useOnboardingDraft();
  const { formatMessage: t } = useIntl();
  const classes = useStyles();
  const add = () => update(current => {
    const unit = { id: Math.min(0, ...current.units.map(item => item.id)) - 1, name: current.unitName.trim() };
    return { ...current, unitName: '', units: [...current.units, unit], unitIds: [...current.unitIds, unit.id] };
  });
  const duplicate = draft.units.some(unit => unit.name.toLowerCase() === draft.unitName.trim().toLowerCase());
  return <>
    <div className={`${classes.compactField} ${classes.leftAlignedField}`}>
      <OnboardingDraftText label={t({ id: 'onboarding.add-company-unit', defaultMessage: 'Add CompanyUnit' })} value={draft.unitName} onChange={unitName => update(current => ({ ...current, unitName }))} />
      <Button color="primary" variant="outlined" onClick={add} disabled={!draft.unitName.trim() || duplicate || draft.unitName.trim().length > 255}>{t({ id: 'form.add' })}</Button>
    </div>
    <MTable data={draft.units} columns={[{ title: t({ id: 'organization.company-units.table.name' }), field: 'name' }]} actions={[unit => ({ icon: 'delete', disabled: unit.id > 0, tooltip: t({ id: 'component.mtable.deleteTooltip' }), onClick: () => update(current => ({ ...current,
      units: current.units.filter(item => item.id !== unit.id), unitIds: current.unitIds.filter(id => id !== unit.id),
      noteUnitIds: Object.fromEntries(Object.entries(current.noteUnitIds).map(([lawId, ids]) => [lawId, ids.filter(id => id !== unit.id)])),
      noteCompanyUnitIds: (current.noteCompanyUnitIds || []).filter(id => id !== unit.id),
      requirements: current.requirements.map(item => ({ ...item, unitIds: item.unitIds.filter(id => id !== unit.id) })),
      requirement: { ...current.requirement, unitIds: current.requirement.unitIds.filter(id => id !== unit.id) },
      notes: Object.fromEntries(Object.entries(current.notes).filter(([key]) => !key.endsWith(`:${unit.id}`))),
    })) })]} />
  </>;
};
